/**
 * Export des services et composants de modal/dialog
 */

// Nouveau service de dialog compatible MatDialog
export { WIZY_DIALOG_DATA, WizyDialogConfig, WizyDialogRef } from './wizy-dialog.model';
export { WizyDialogService } from './wizy-dialog.service';
